var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMachineBelt2B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 598 536.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-11,.cls-13,.cls-19,.cls-35,.cls-44,.cls-51,.cls-52,.cls-9{fill:none;}.cls-2{fill:#dcb998;}.cls-3{fill:#c5a07d;}.cls-4{fill:#ececec;}.cls-5{fill:#c8cad1;}.cls-6{fill:#c07145;}.cls-7{fill:#f18956;}.cls-8{fill:#ded6ce;}.cls-9{stroke:#a3866a;}.cls-10,.cls-11,.cls-13,.cls-19,.cls-20,.cls-35,.cls-44,.cls-51,.cls-52,.cls-9{stroke-miterlimit:10;}.cls-10{stroke:#f2dac5;}.cls-11{stroke:#fdebdd;}.cls-12{fill:#f2dac5;}.cls-13{stroke:#dcb998;}.cls-14{fill:#9caab2;}.cls-15{fill:#ccd6e5;}.cls-16{fill:#b8bcc0;}.cls-17{fill:#343f42;}.cls-18,.cls-20{fill:#d0d6e0;}.cls-19,.cls-20{stroke:#343f42;}.cls-21{fill:#fff;}.cls-22{fill:#d9e6ed;}.cls-23{fill:#acc6d1;}.cls-24{fill:#1b5f9c;}.cls-25{opacity:0.4;}.cls-26{fill:#9aa4ae;}.cls-27{fill:#b8bcc1;}.cls-28{fill:#495d66;}.cls-29{fill:#85929c;}.cls-30{fill:#1f6aae;}.cls-31{fill:#257ac1;}.cls-32{fill:#8d9aa0;}.cls-33{fill:#7c878c;}.cls-34{fill:#2a3335;}.cls-35{stroke:#124c77;}.cls-36{fill:#86939c;}.cls-37{fill:#303b3e;}.cls-38{fill:#f44d4d;}.cls-39{fill:#f66562;}.cls-40{fill:#d0d6e2;}.cls-41{fill:#124c77;}.cls-42{fill:#8ab3ff;}.cls-43{fill:#588df0;}.cls-44{stroke:#588df0;}.cls-45{fill:#cbd5e4;}.cls-46{fill:#b9bdc1;}.cls-47{fill:#1a3447;}.cls-48{fill:#6c8197;}.cls-49{fill:#dadada;}.cls-50{clip-path:url(#clip-path);}.cls-51{stroke:#fff;}.cls-52{stroke:#bdbdbd;stroke-width:2px;}.cls-53{fill:#bdbdbd;}.cls-54{fill:#960002;}.cls-55{fill:#ff031c;}.cls-56{fill:#b97109;}.cls-57{fill:#ff9c0e;}.cls-58{fill:#02782c;}.cls-59{fill:#00de42;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,2.17C9.88,1.49,9.13.82,7.77.4,5.48-.3,2.38-.06.85,1A1.52,1.52,0,0,0,0,2.17H0v0H0L0,76.85c.08.68.83,1.34,2.19,1.76,2.28.71,5.38.46,6.92-.55A1.57,1.57,0,0,0,10,76.85h0v0h0V2.17Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Jar_01a",
    "data-name": "Jar_01a",
    viewBox: "0 0 9.26 20.07"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_24",
    "data-name": "New Symbol 24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M9.26,5.87h0c0-.64-.75-1.27-2-1.67-2.12-.65-5-.43-6.42.5A1.41,1.41,0,0,0,0,5.87H0V18H0c0,.64.75,1.28,2.05,1.67,2.12.65,5,.43,6.42-.5A1.41,1.41,0,0,0,9.26,18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M8.33,2.74h0c0-.51-.59-1-1.63-1.34a7,7,0,0,0-5.14.4,1.1,1.1,0,0,0-.63.94h0v2h0c0,.52.59,1,1.63,1.34a7,7,0,0,0,5.14-.4,1.08,1.08,0,0,0,.63-.94h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M9.26,5.87s0,0,0-.08a1.33,1.33,0,0,1-.76,1.26,8.8,8.8,0,0,1-6.42.5c-1.31-.4-2-1-2-1.68H0V18H0c0,.64.75,1.28,2.05,1.67,2.12.65,5,.43,6.42-.5A1.41,1.41,0,0,0,9.26,18h0V5.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2.05,7.55c-1.3-.4-2-1-2-1.68H0V18H0c0,.64.75,1.28,2.05,1.67Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M8.48,1.7h0c0-.53-.62-1.06-1.7-1.39A7.33,7.33,0,0,0,1.43.73a1.14,1.14,0,0,0-.65,1h0V3.77h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 4.63,
    cy: 1.7,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(2.88 6.32) rotate(-89.38)"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Jars_05",
    "data-name": "Jars_05",
    viewBox: "0 0 53.82 38.35"
  }, /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 20.06,
    transform: "translate(44.56 9.31)",
    xlinkHref: "#Jar_01a"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 20.06,
    transform: "translate(27.6)",
    xlinkHref: "#Jar_01a"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 20.06,
    transform: "translate(16.96 18.29)",
    xlinkHref: "#Jar_01a"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.26,
    height: 20.06,
    transform: "translate(0 8.98)",
    xlinkHref: "#Jar_01a"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Interface_02b",
    "data-name": "Interface_02b",
    viewBox: "0 0 33.25 48.54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "6.65 12.54 6.65 48.54 33.25 39.9 33.25 3.9 6.65 12.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "26.56 0 33.25 3.9 6.65 12.54 0 8.7 26.56 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "0 8.7 6.65 12.54 6.65 48.54 0 44.7 0 8.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "23.27 10.14 23.27 25.14 29.93 22.98 29.93 7.98 23.27 10.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "23.27 28.14 23.27 40.14 29.93 37.98 29.93 25.98 23.27 28.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 9.97,
    y1: 17.46,
    x2: 19.85,
    y2: 14.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 9.97,
    y1: 20.46,
    x2: 19.85,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 9.97,
    y1: 23.46,
    x2: 19.85,
    y2: 20.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "9.97 29.46 19.95 26.22 19.95 41.22 9.97 44.46 9.97 29.46"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "WarningLightOff_01",
    "data-name": "WarningLightOff_01",
    viewBox: "0 0 9.97 79.77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M10,2.17C9.88,1.49,9.13.82,7.77.4,5.48-.3,2.38-.06.85,1A1.52,1.52,0,0,0,0,2.17H0v0H0L0,76.85c.08.68.83,1.34,2.19,1.76,2.28.71,5.38.46,6.92-.55A1.57,1.57,0,0,0,10,76.85h0v0h0V2.17Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-51",
    x1: 1.65,
    y1: 2.49,
    x2: 1.65,
    y2: 79.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-52",
    x1: 7.28,
    y1: 2.49,
    x2: 7.28,
    y2: 79.77
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-53",
    cx: 4.99,
    cy: 2.22,
    rx: 2.2,
    ry: 4.99,
    transform: "translate(2.72 7.18) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M10,4.22a1.47,1.47,0,0,1-.83,1.32c-1.54,1-4.64,1.24-6.92.54C.78,5.64,0,5,0,4.25L0,13.5c.07.67.82,1.34,2.18,1.76,2.29.7,5.38.46,6.92-.55A1.57,1.57,0,0,0,10,13.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 3.38,
    y: 7.97,
    width: 3.16,
    height: 5.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M10,13.39a1.47,1.47,0,0,1-.83,1.32c-1.54,1-4.63,1.24-6.92.54C.78,14.81,0,14.13,0,13.42l0,9.25c.07.68.82,1.34,2.18,1.76,2.29.71,5.38.46,6.92-.55A1.52,1.52,0,0,0,10,22.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 3.38,
    y: 17.15,
    width: 3.16,
    height: 5.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M10,22.57a1.46,1.46,0,0,1-.83,1.31c-1.54,1-4.63,1.24-6.92.54C.78,24,0,23.3,0,22.59l0,9.25c.07.68.82,1.34,2.18,1.76,2.29.71,5.38.46,6.92-.54A1.54,1.54,0,0,0,10,31.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 3.38,
    y: 26.21,
    width: 3.16,
    height: 5.42
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Screen_01b",
    "data-name": "Screen_01b",
    viewBox: "0 0 56.52 74.04"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "6.65 20.04 56.52 3.84 49.87 0 0 16.2 6.65 20.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "0 70.2 0 16.2 6.65 20.04 6.65 74.04 0 70.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "56.52 3.84 6.65 20.04 6.65 74.04 56.52 57.84 56.52 3.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "53.27 11.01 9.97 24.96 9.97 60.96 53.2 46.92 53.27 11.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "49.87 15 13.3 26.88 13.3 56.88 49.87 45 49.87 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "16.63 28.8 16.63 52.8 29.93 48.48 29.93 24.48 16.63 28.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-44",
    x1: 46.55,
    y1: 22.08,
    x2: 33.25,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-44",
    x1: 46.55,
    y1: 28.08,
    x2: 33.25,
    y2: 32.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-44",
    x1: 46.55,
    y1: 34.08,
    x2: 33.25,
    y2: 38.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-44",
    x1: 46.55,
    y1: 40.08,
    x2: 33.25,
    y2: 44.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M48.32,57.73a2.8,2.8,0,0,0,1.67,0,4.17,4.17,0,0,0,2.77-3.86,3.33,3.33,0,0,0-2.25-3.23,2.8,2.8,0,0,0-1.67,0,4.17,4.17,0,0,0-2.77,3.86A3.3,3.3,0,0,0,48.32,57.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M47.24,54.86a3.3,3.3,0,0,1,2.18-3,1.71,1.71,0,0,1,1.49.16h0l0,0,3.18,2h0a1.68,1.68,0,0,1,.68,1.45,3.32,3.32,0,0,1-2.18,3,1.71,1.71,0,0,1-1.47-.16l-3.23-2.07A1.66,1.66,0,0,1,47.24,54.86Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-39",
    cx: 52.65,
    cy: 56.25,
    rx: 2.6,
    ry: 1.91,
    transform: "translate(-23.78 65.92) rotate(-54.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M38.6,60.77a2.8,2.8,0,0,0,1.67,0A4.15,4.15,0,0,0,43,56.88a3.29,3.29,0,0,0-2.25-3.22,2.85,2.85,0,0,0-1.66,0,4.15,4.15,0,0,0-2.77,3.87A3.3,3.3,0,0,0,38.6,60.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M37.52,57.89a3.32,3.32,0,0,1,2.18-3,1.68,1.68,0,0,1,1.49.17h0l0,0,3.18,2h0a1.68,1.68,0,0,1,.68,1.44,3.3,3.3,0,0,1-2.18,3,1.71,1.71,0,0,1-1.47-.15l-3.24-2.07A1.7,1.7,0,0,1,37.52,57.89Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-39",
    cx: 42.93,
    cy: 59.28,
    rx: 2.6,
    ry: 1.91,
    transform: "translate(-30.27 59.3) rotate(-54.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M30.5,63A2.55,2.55,0,0,0,32,63a4,4,0,0,0,2.62-3.64,2.89,2.89,0,0,0-2-2.83,2.55,2.55,0,0,0-1.52,0,4,4,0,0,0-2.62,3.64A2.88,2.88,0,0,0,30.5,63Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 31.59,
    cy: 59.74,
    rx: 2.6,
    ry: 1.91,
    transform: "translate(-35.32 50.31) rotate(-54.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M22.4,65.52a2.63,2.63,0,0,0,1.52,0,4,4,0,0,0,2.62-3.64,2.9,2.9,0,0,0-2-2.83,2.63,2.63,0,0,0-1.52,0,4,4,0,0,0-2.62,3.64A2.89,2.89,0,0,0,22.4,65.52Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 23.49,
    cy: 62.27,
    rx: 2.6,
    ry: 1.91,
    transform: "translate(-40.73 44.79) rotate(-54.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M14.29,68a2.58,2.58,0,0,0,1.53,0,4,4,0,0,0,2.62-3.64,2.9,2.9,0,0,0-2-2.83,2.47,2.47,0,0,0-1.52,0,4,4,0,0,0-2.62,3.63A2.88,2.88,0,0,0,14.29,68Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 15.39,
    cy: 64.8,
    rx: 2.6,
    ry: 1.91,
    transform: "translate(-46.13 39.28) rotate(-54.11)"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Screen_Arm_02b",
    "data-name": "Screen_Arm_02b",
    viewBox: "0 0 83.12 135.84"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "19.95 47.16 39.9 40.68 19.95 29.16 0 35.64 19.95 47.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "59.85 25.2 59.85 67.2 53.2 69.36 53.2 27.36 59.85 25.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "46.55 29.52 46.55 71.52 53.2 69.36 53.2 27.36 46.55 29.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "53.2 15.36 33.25 3.84 26.6 6 46.55 17.52 53.2 15.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "43.22 24.6 19.95 11.16 26.6 6 46.55 17.52 43.22 24.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "26.6 15 26.6 39 19.95 41.16 19.95 11.16 26.6 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "13.3 7.32 13.3 37.32 19.95 41.16 19.95 11.16 13.3 7.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "46.55 17.52 53.2 27.36 46.55 29.52 43.22 24.6 46.55 17.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "53.2 15.36 59.85 25.2 53.2 27.36 46.55 17.52 53.2 15.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "26.6 6 19.95 11.16 13.3 7.32 19.95 2.16 26.6 6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "33.25 3.84 26.6 6 19.95 2.16 26.6 0 33.25 3.84"
  }), /*#__PURE__*/React.createElement("use", {
    width: 56.52,
    height: 74.04,
    transform: "translate(26.6 61.79)",
    xlinkHref: "#Screen_01b"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "BoxOpen_02a",
    "data-name": "BoxOpen_02a",
    viewBox: "0 0 119.7 94.43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.3 16.85 53.2 39.88 59.85 37.72 59.85 1.72 13.3 16.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "99.75 24.76 59.85 37.72 59.85 1.72 99.75 24.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.21,32.7a1.6,1.6,0,0,0-.91-1.2l0-1.94h0c0-.52-.58-1-1.62-1.36a7.66,7.66,0,0,0-4.4,0,2.44,2.44,0,0,0-.65-.55l0-1.94h0c0-.52-.58-1-1.62-1.36a7.66,7.66,0,0,0-4.4,0,2.44,2.44,0,0,0-.65-.55l0-1.94h0c0-.51-.58-1-1.62-1.36a7.66,7.66,0,0,0-4.4,0,2.44,2.44,0,0,0-.65-.55l0-1.94h0c0-.51-.58-1-1.62-1.36a7.66,7.66,0,0,0-4.4,0,2.44,2.44,0,0,0-.65-.55l0-1.94h0c0-.51-.58-1-1.62-1.36a7,7,0,0,0-5.14.35,1.11,1.11,0,0,0-.64.93h0l0,1.88-.14.08a1.38,1.38,0,0,0-.8,1.16h0l0,1.67-.13-.07V16.9h0c0-.52-.59-1-1.63-1.34a7,7,0,0,0-5.14.4c-.44.29-.65.61-.63.94h0v1.88l-.14.07A1.41,1.41,0,0,0,47.88,20h0v1.6l-.09-.05V19.64h0c0-.52-.6-1-1.64-1.34a7,7,0,0,0-5.14.4,1.12,1.12,0,0,0-.63.94h0v1.88a.91.91,0,0,0-.14.07,1.4,1.4,0,0,0-.78,1.18h0v1.59l-.09-.05V22.37h0c0-.51-.59-1-1.63-1.34a7,7,0,0,0-5.14.4,1.12,1.12,0,0,0-.63.94h0v1.89l-.14.07A1.43,1.43,0,0,0,31,25.5h0v1.6l-.09-.05V25.11h0c0-.51-.6-1-1.64-1.34a7,7,0,0,0-5.14.4,1.11,1.11,0,0,0-.62.94h0V27l-.13.08a1.36,1.36,0,0,0-.79,1.17h0v1.6l-.09-.05V27.85h0c0-.52-.6-1-1.64-1.34a7,7,0,0,0-5.14.4,1.12,1.12,0,0,0-.63.94h0v1.88a.91.91,0,0,1-.14.07A1.4,1.4,0,0,0,14.19,31h0V43.12h0c0,.65.74,1.28,2,1.68a9.81,9.81,0,0,0,4.6.17v2h0c0,.64.74,1.28,2,1.68a9.81,9.81,0,0,0,4.6.17v2h0c0,.64.74,1.28,2,1.68a9.81,9.81,0,0,0,4.6.17v2h0c0,.64.74,1.28,2,1.68a10,10,0,0,0,4.6.17v2h0c0,.64.74,1.28,2,1.67,2.12.65,5,.43,6.43-.5A1.38,1.38,0,0,0,50,58.48h0v-1.6a4.79,4.79,0,0,0,1.22.54,8.81,8.81,0,0,0,6.42-.5,1.4,1.4,0,0,0,.78-1.18h0v-1.6a4.71,4.71,0,0,0,1.21.54,8.8,8.8,0,0,0,6.42-.5A1.39,1.39,0,0,0,66.89,53h0V51.41a5.28,5.28,0,0,0,1.21.53c2.13.65,5,.43,6.43-.5a1.39,1.39,0,0,0,.78-1.17h0v-1.6a4.91,4.91,0,0,0,1.21.54c2.12.64,5,.42,6.42-.51a1.38,1.38,0,0,0,.79-1.17h0V45.94a4.79,4.79,0,0,0,1.11.5c2.12.67,5,.48,6.43-.43a1.38,1.38,0,0,0,.8-1.17h0l.13-12.14Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 61.02,
    cy: 14.35,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(45.35 75.04) rotate(-88.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 52.51,
    cy: 17.09,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(34.86 69.41) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 44.09,
    cy: 19.82,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(23.79 63.69) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 35.66,
    cy: 22.56,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(12.72 57.98) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 27.24,
    cy: 25.3,
    rx: 1.31,
    ry: 2.96,
    transform: "matrix(0.01, -1, 1, 0.01, 1.65, 52.26)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 18.81,
    cy: 28.03,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(-9.42 46.54) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 67.67,
    cy: 18.19,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(48.02 85.45) rotate(-88.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 59.16,
    cy: 20.93,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(37.6 79.86) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 50.74,
    cy: 23.66,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(26.53 74.14) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 42.31,
    cy: 26.4,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(15.46 68.42) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 33.89,
    cy: 29.14,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(4.39 62.71) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 25.46,
    cy: 31.87,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(-6.68 56.99) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 74.32,
    cy: 22.03,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(50.69 95.85) rotate(-88.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 65.81,
    cy: 24.76,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(40.34 90.3) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 57.39,
    cy: 27.5,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(29.27 84.59) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 48.96,
    cy: 30.24,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(18.19 78.87) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 40.54,
    cy: 32.98,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(7.12 73.15) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 32.11,
    cy: 35.71,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(-3.95 67.44) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 80.97,
    cy: 25.87,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(53.35 106.26) rotate(-88.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 72.46,
    cy: 28.6,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(43.07 100.75) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 64.04,
    cy: 31.34,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(32 95.03) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 55.61,
    cy: 34.08,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(20.93 89.32) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 47.19,
    cy: 36.82,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(9.86 83.6) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 38.76,
    cy: 39.55,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(-1.21 77.89) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 87.62,
    cy: 29.71,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(56.02 116.66) rotate(-88.76)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 79.11,
    cy: 32.44,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(45.81 111.2) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 70.69,
    cy: 35.18,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(34.74 105.48) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 62.26,
    cy: 37.92,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(23.67 99.77) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 53.84,
    cy: 40.65,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(12.6 94.05) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 45.41,
    cy: 43.39,
    rx: 1.31,
    ry: 2.96,
    transform: "translate(1.53 88.33) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M64.8,13.82h0c0-.53-.62-1.06-1.7-1.39a7.28,7.28,0,0,0-5.35.42,1.14,1.14,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 60.95,
    cy: 13.82,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(46.47 74.62) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M71.45,17.66h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.41,1.15,1.15,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 67.6,
    cy: 17.66,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(49.21 85.07) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.1,21.5h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.41,1.15,1.15,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 74.25,
    cy: 21.5,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(51.95 95.52) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M84.75,25.34h0c0-.54-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.41,1.15,1.15,0,0,0-.65,1h0v2.07h0c0,.54.62,1.06,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 80.9,
    cy: 25.34,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(54.69 105.96) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.4,29.18h0c0-.54-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.41,1.15,1.15,0,0,0-.65,1h0v2.07h0c0,.54.62,1.06,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 87.55,
    cy: 29.18,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(57.42 116.41) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M56.44,16.37h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.42,1.18,1.18,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 52.58,
    cy: 16.37,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(35.64 68.78) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M63.09,20.21h0c0-.53-.62-1.06-1.7-1.39a7.28,7.28,0,0,0-5.35.42,1.17,1.17,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 59.23,
    cy: 20.21,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(38.38 79.22) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M69.74,24.05h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.41,1.19,1.19,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 65.88,
    cy: 24.05,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(41.12 89.67) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.39,27.89h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.41,1.17,1.17,0,0,0-.65,1h0V30h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 72.53,
    cy: 27.89,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(43.86 100.12) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M83,31.73h0c0-.54-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.41,1.15,1.15,0,0,0-.65,1h0V33.8h0c0,.54.62,1.06,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 79.18,
    cy: 31.73,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(46.6 110.57) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M48.07,18.92h0c0-.53-.62-1.06-1.71-1.39A7.3,7.3,0,0,0,41,18a1.17,1.17,0,0,0-.66,1h0V21h0c0,.54.62,1.07,1.71,1.4A7.3,7.3,0,0,0,47.41,22a1.19,1.19,0,0,0,.66-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 44.21,
    cy: 18.92,
    rx: 1.7,
    ry: 3.85,
    transform: "matrix(0.01, -1, 1, 0.01, 24.81, 62.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M54.72,22.76h0c0-.53-.62-1.06-1.71-1.39a7.25,7.25,0,0,0-5.34.42,1.17,1.17,0,0,0-.66,1h0v2.07h0c0,.54.62,1.07,1.71,1.4a7.3,7.3,0,0,0,5.34-.42,1.19,1.19,0,0,0,.66-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 50.86,
    cy: 22.76,
    rx: 1.7,
    ry: 3.85,
    transform: "matrix(0.01, -1, 1, 0.01, 27.55, 73.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M61.37,26.6h0c0-.53-.62-1.06-1.71-1.39a7.3,7.3,0,0,0-5.34.41,1.19,1.19,0,0,0-.66,1h0v2.07h0c0,.54.62,1.07,1.71,1.4a7.3,7.3,0,0,0,5.34-.42,1.19,1.19,0,0,0,.66-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 57.51,
    cy: 26.6,
    rx: 1.7,
    ry: 3.85,
    transform: "matrix(0.01, -1, 1, 0.01, 30.29, 83.83)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68,30.44h0c0-.53-.62-1.06-1.71-1.39a7.3,7.3,0,0,0-5.34.41,1.19,1.19,0,0,0-.66,1h0v2.07h0c0,.54.62,1.07,1.71,1.4a7.3,7.3,0,0,0,5.34-.42,1.19,1.19,0,0,0,.66-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 64.16,
    cy: 30.44,
    rx: 1.7,
    ry: 3.85,
    transform: "matrix(0.01, -1, 1, 0.01, 33.03, 94.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M74.67,34.28h0c0-.54-.62-1.06-1.71-1.39a7.3,7.3,0,0,0-5.34.41,1.19,1.19,0,0,0-.66,1h0v2.07h0c0,.54.62,1.06,1.71,1.4A7.3,7.3,0,0,0,74,37.33a1.19,1.19,0,0,0,.66-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 70.81,
    cy: 34.28,
    rx: 1.7,
    ry: 3.85,
    transform: "matrix(0.01, -1, 1, 0.01, 35.77, 104.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M39.7,21.47h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.42,1.14,1.14,0,0,0-.65,1h0v2.07h0c0,.54.61,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.19,1.19,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 35.85,
    cy: 21.47,
    rx: 1.7,
    ry: 3.85,
    transform: "matrix(0.01, -1, 1, 0.01, 13.99, 57.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M46.35,25.31h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.42,1.14,1.14,0,0,0-.65,1h0v2.07h0c0,.54.61,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.19,1.19,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 42.5,
    cy: 25.31,
    rx: 1.7,
    ry: 3.85,
    transform: "matrix(0.01, -1, 1, 0.01, 16.72, 67.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53,29.15h0c0-.53-.62-1.06-1.7-1.39a7.28,7.28,0,0,0-5.35.42,1.13,1.13,0,0,0-.65,1h0v2.07h0c0,.54.61,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.19,1.19,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 49.15,
    cy: 29.15,
    rx: 1.7,
    ry: 3.85,
    transform: "matrix(0.01, -1, 1, 0.01, 19.46, 77.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M59.65,33h0c0-.53-.62-1.06-1.7-1.39A7.32,7.32,0,0,0,52.6,32a1.19,1.19,0,0,0-.66,1h0v2.07h0c0,.54.62,1.07,1.71,1.4A7.3,7.3,0,0,0,59,36a1.19,1.19,0,0,0,.66-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 55.8,
    cy: 32.99,
    rx: 1.7,
    ry: 3.85,
    transform: "matrix(0.01, -1, 1, 0.01, 22.2, 88.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M66.3,36.83h0c0-.53-.62-1.06-1.7-1.39a7.32,7.32,0,0,0-5.35.41,1.19,1.19,0,0,0-.66,1h0V38.9h0c0,.54.62,1.07,1.71,1.4a7.3,7.3,0,0,0,5.34-.42,1.19,1.19,0,0,0,.66-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 62.45,
    cy: 36.83,
    rx: 1.7,
    ry: 3.85,
    transform: "matrix(0.01, -1, 1, 0.01, 24.94, 98.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M31.33,24h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.42,1.14,1.14,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 27.48,
    cy: 24.02,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(3.16 51.24) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M38,27.86h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.42,1.14,1.14,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 34.13,
    cy: 27.86,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(5.9 61.69) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M44.63,31.7h0c0-.53-.62-1.06-1.7-1.39a7.28,7.28,0,0,0-5.35.42,1.14,1.14,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4A7.33,7.33,0,0,0,44,34.75a1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 40.78,
    cy: 31.7,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(8.64 72.14) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M51.28,35.54h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.41,1.15,1.15,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 47.43,
    cy: 35.54,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(11.38 82.58) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M57.93,39.38h0c0-.53-.62-1.06-1.7-1.39a7.33,7.33,0,0,0-5.35.41,1.15,1.15,0,0,0-.65,1h0v2.07h0c0,.54.62,1.07,1.7,1.4a7.33,7.33,0,0,0,5.35-.42,1.15,1.15,0,0,0,.65-1h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 54.08,
    cy: 39.38,
    rx: 1.7,
    ry: 3.85,
    transform: "translate(14.11 93.03) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "99.75 24.76 53.2 39.88 53.2 93.88 99.75 78.76 99.75 24.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "13.3 16.85 53.2 39.88 53.2 93.88 13.3 70.85 13.3 16.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "33.25 34.36 46.55 42.04 46.55 54.04 33.25 46.36 33.25 34.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 53.2,
    y1: 39.88,
    x2: 53.2,
    y2: 93.88
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "99.75 78.76 53.2 93.88 13.3 70.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 99.75,
    y1: 24.76,
    x2: 99.75,
    y2: 78.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 59.85,
    y1: 1.72,
    x2: 99.75,
    y2: 24.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "53.2 39.88 99.75 24.76 113.05 44.44 66.5 59.56 53.2 39.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "13.3 16.85 53.2 39.88 39.9 56.2 0 33.17 13.3 16.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "79.8 7.24 59.85 1.72 99.75 24.76 119.7 30.27 79.8 7.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "46.48 0 59.85 1.72 13.3 16.85 0 15.17 46.48 0"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Box_01a",
    "data-name": "Box_01a",
    viewBox: "0 0 87.2 93.25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0.25 15.67 40.15 38.7 40.15 92.7 0.25 69.67 0.25 15.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "86.7 23.58 40.15 38.7 40.15 92.7 86.7 77.58 86.7 23.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "0.25 15.67 40.15 38.7 86.7 23.58 46.8 0.54 0.25 15.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 23.49,
    y1: 8.12,
    x2: 63.39,
    y2: 31.15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "20.2 33.19 33.5 40.87 33.5 52.87 20.2 45.19 20.2 33.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 40.15,
    y1: 38.7,
    x2: 40.15,
    y2: 92.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "86.7 77.58 40.15 92.7 0.25 69.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 86.7,
    y1: 23.58,
    x2: 86.7,
    y2: 77.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "0.25 15.67 46.8 0.54 86.7 23.58"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Machine_Belt_02_New",
    "data-name": "Machine_Belt_02_New",
    viewBox: "0 0 598 536.9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Machine_Belt_02"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "155.88 177.01 285.55 134.88 285.55 44.88 155.88 87.01 155.88 177.01"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("image", {
    width: 598,
    height: 443,
    transform: "translate(0 93.9)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M561.52,96.21,175.82,221.53v36l385.7-125.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "36.18 212.9 501.67 61.65 561.52 96.21 175.82 221.53 375.32 336.71 295.52 362.63 36.18 212.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "548.22 94.53 162.53 219.85 361.5 334.74 295.52 356.63 49.48 214.58 501.67 67.65 548.22 94.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "36.18 212.9 36.18 248.9 295.52 398.63 295.52 362.63 36.18 212.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "242.32 379.92 242.32 415.92 332.1 467.75 332.1 431.75 242.32 379.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "375.32 336.71 375.32 372.61 295.52 398.63 295.52 362.63 375.32 336.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "242.32 379.92 332.1 431.75 504.99 375.57 415.22 323.74 242.32 379.92"
  }), /*#__PURE__*/React.createElement("use", {
    width: 53.82,
    height: 38.35,
    transform: "translate(467.65 66.65)",
    xlinkHref: "#Jars_05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "504.99 375.57 504.99 411.48 332.1 467.75 332.1 431.75 504.99 375.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "295.52 128.63 355.37 109.19 355.37 94.19 295.52 59.63 295.52 128.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "355.37 175.19 355.37 94.19 295.52 59.63 295.52 128.63 285.55 131.88 285.55 44.88 365.35 90.95 365.35 180.95 355.37 175.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "285.55 44.88 415.22 2.74 495.02 48.81 365.35 90.95 285.55 44.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "365.35 180.95 495.02 138.81 495.02 48.81 365.35 90.95 365.35 180.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "551.54 135.45 551.54 159.45 544.89 161.61 544.89 137.61 551.54 135.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "538.24 139.77 538.24 157.77 544.89 161.61 544.89 137.61 538.24 139.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "551.54 159.45 551.54 168.45 544.89 170.61 544.89 161.61 551.54 159.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "538.24 157.77 538.24 166.77 544.89 170.61 544.89 161.61 538.24 157.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "465.1 163.54 465.1 187.54 458.44 189.7 458.44 165.7 465.1 163.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "451.8 167.86 451.8 185.86 458.44 189.7 458.44 165.7 451.8 167.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "465.1 187.54 465.1 196.54 458.44 198.7 458.44 189.7 465.1 187.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "451.8 185.86 451.8 194.86 458.44 198.7 458.44 189.7 451.8 185.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "378.65 191.63 378.65 215.63 372 217.79 372 193.79 378.65 191.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "365.35 195.95 365.35 213.95 372 217.79 372 193.79 365.35 195.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "378.65 215.63 378.65 224.63 372 226.79 372 217.79 378.65 215.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "365.35 213.95 365.35 222.95 372 226.79 372 217.79 365.35 213.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "295.52 218.63 295.52 242.63 288.87 244.8 288.87 220.8 295.52 218.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "282.22 222.96 282.22 240.96 288.87 244.8 288.87 220.8 282.22 222.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "295.52 242.63 295.52 251.63 288.87 253.8 288.87 244.8 295.52 242.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "282.22 240.96 282.22 249.96 288.87 253.8 288.87 244.8 282.22 240.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "62.78 264.26 62.78 282.26 56.13 284.42 56.13 260.42 62.78 264.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "49.48 256.58 49.48 280.58 56.13 284.42 56.13 260.42 49.48 256.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "62.78 282.26 62.78 291.26 56.13 293.42 56.13 284.42 62.78 282.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "49.48 280.58 49.48 289.58 56.13 293.42 56.13 284.42 49.48 280.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "142.57 310.33 142.57 328.33 135.93 330.49 135.93 306.49 142.57 310.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "129.28 302.65 129.28 326.65 135.93 330.49 135.93 306.49 129.28 302.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "142.57 328.33 142.57 337.33 135.93 339.49 135.93 330.49 142.57 328.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "129.28 326.65 129.28 335.65 135.93 339.49 135.93 330.49 129.28 326.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "222.37 356.4 222.37 374.4 215.72 376.56 215.72 352.56 222.37 356.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "209.07 348.72 209.07 372.72 215.72 376.56 215.72 352.56 209.07 348.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "222.37 374.4 222.37 383.4 215.72 385.56 215.72 376.56 222.37 374.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "209.07 372.72 209.07 381.72 215.72 385.56 215.72 376.56 209.07 372.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "265.6 429.36 265.6 447.36 258.95 449.52 258.95 425.52 265.6 429.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "252.3 421.68 252.3 445.68 258.95 449.52 258.95 425.52 252.3 421.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "265.6 447.36 265.6 456.36 258.95 458.52 258.95 449.52 265.6 447.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "252.3 445.68 252.3 454.68 258.95 458.52 258.95 449.52 252.3 445.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "338.75 465.59 338.75 489.59 332.1 491.75 332.1 467.75 338.75 465.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "325.45 463.91 325.45 487.91 332.1 491.75 332.1 467.75 325.45 463.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "338.75 489.59 338.75 498.59 332.1 500.75 332.1 491.75 338.75 489.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "325.45 487.91 325.45 496.91 332.1 500.75 332.1 491.75 325.45 487.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "492.12 415.47 492.12 439.47 485.47 441.63 485.47 417.63 492.12 415.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "478.82 419.79 478.82 437.79 485.47 441.63 485.47 417.63 478.82 419.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "492.12 439.47 492.12 448.47 485.47 450.63 485.47 441.63 492.12 439.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "478.82 437.79 478.82 446.79 485.47 450.63 485.47 441.63 478.82 437.79"
  }), /*#__PURE__*/React.createElement("use", {
    width: 33.25,
    height: 48.54,
    transform: "translate(379.31 94.93)",
    xlinkHref: "#Interface_02b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 9.98,
    height: 79.77,
    transform: "translate(364.66)",
    xlinkHref: "#WarningLightOff_01"
  }), /*#__PURE__*/React.createElement("use", {
    width: 83.12,
    height: 135.84,
    transform: "translate(405.25 9.34)",
    xlinkHref: "#Screen_Arm_02b"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "225.7 217.32 225.7 136.32 165.85 101.77 165.85 170.77 155.88 174.01 155.88 87.01 235.67 133.08 235.67 223.08 225.7 217.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "155.88 87.01 285.55 44.88 365.35 90.95 235.67 133.08 155.88 87.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "235.67 223.08 365.35 180.95 365.35 90.95 235.67 133.08 235.67 223.08"
  }), /*#__PURE__*/React.createElement("use", {
    width: 119.7,
    height: 94.43,
    transform: "translate(124.06 125.89) scale(0.9)",
    xlinkHref: "#BoxOpen_02a"
  }), /*#__PURE__*/React.createElement("use", {
    width: 119.7,
    height: 94.43,
    transform: "translate(52.23 152.82) scale(0.9)",
    xlinkHref: "#BoxOpen_02a"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "307.6 126.41 307.6 171.41 360.8 154.13 360.8 109.13 307.6 126.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "251.07 144.78 251.07 186.78 297.62 171.65 297.62 129.65 251.07 144.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M280.31,148.23a2.72,2.72,0,0,1-2.74-2.82,4.53,4.53,0,0,1,3.06-4.1,3.61,3.61,0,0,1,1.06-.17,2.72,2.72,0,0,1,2.74,2.82,4.51,4.51,0,0,1-3.06,4.1A3.56,3.56,0,0,1,280.31,148.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M285.81,144.47l-3.21-1.85a1.77,1.77,0,0,0-1.6-.17,3.37,3.37,0,0,0-2.23,3,1.62,1.62,0,0,0,.53,1.25l3.58,2.1a1.83,1.83,0,0,0,1.45.07,3.35,3.35,0,0,0,2.23-3A1.56,1.56,0,0,0,285.81,144.47Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-39",
    cx: 284.33,
    cy: 146.6,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-11.57 268.18) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M290.29,145a2.72,2.72,0,0,1-2.74-2.82,4.51,4.51,0,0,1,3.06-4.1,3.56,3.56,0,0,1,1.06-.17,2.72,2.72,0,0,1,2.74,2.82,4.53,4.53,0,0,1-3.06,4.1A3.66,3.66,0,0,1,290.29,145Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M295.78,141.23l-3.2-1.85a1.78,1.78,0,0,0-1.6-.17,3.37,3.37,0,0,0-2.23,3,1.59,1.59,0,0,0,.53,1.25l3.58,2.1a1.81,1.81,0,0,0,1.44.07,3.35,3.35,0,0,0,2.23-3A1.54,1.54,0,0,0,295.78,141.23Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-39",
    cx: 294.3,
    cy: 143.36,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-5.59 274.64) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M279.25,157.94a2.4,2.4,0,0,1-2.44-2.52,4.25,4.25,0,0,1,2.85-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.45,2.52,4.26,4.26,0,0,1-2.86,3.81A3,3,0,0,1,279.25,157.94Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 279.94,
    cy: 154.69,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-19.27 267.69) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M285.9,155.78a2.4,2.4,0,0,1-2.45-2.52,4.26,4.26,0,0,1,2.86-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.45,2.52,4.27,4.27,0,0,1-2.86,3.81A3.27,3.27,0,0,1,285.9,155.78Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 286.59,
    cy: 152.53,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-15.29 271.99) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M292.55,153.62a2.4,2.4,0,0,1-2.45-2.52,4.26,4.26,0,0,1,2.86-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.45,2.52,4.27,4.27,0,0,1-2.86,3.81A3.27,3.27,0,0,1,292.55,153.62Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 293.24,
    cy: 150.37,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-11.3 276.3) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M271.61,172.06a2.9,2.9,0,0,1-2.95-3.05,5.16,5.16,0,0,1,3.45-4.61,3.76,3.76,0,0,1,1.17-.19,2.91,2.91,0,0,1,3,3,5.17,5.17,0,0,1-3.45,4.61A3.78,3.78,0,0,1,271.61,172.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 272.45,
    cy: 168.13,
    rx: 3.17,
    ry: 2.3,
    transform: "translate(-32.15 266.72) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M281.59,168.82a2.9,2.9,0,0,1-2.95-3,5.14,5.14,0,0,1,3.45-4.61,3.72,3.72,0,0,1,1.17-.19,2.9,2.9,0,0,1,2.95,3.05,5.15,5.15,0,0,1-3.45,4.61A3.72,3.72,0,0,1,281.59,168.82Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 282.42,
    cy: 164.89,
    rx: 3.17,
    ry: 2.3,
    transform: "translate(-26.17 273.17) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M291.56,165.58a2.9,2.9,0,0,1-2.95-3.05,5.16,5.16,0,0,1,3.45-4.61,3.78,3.78,0,0,1,1.17-.2,2.91,2.91,0,0,1,3,3.05,5.17,5.17,0,0,1-3.45,4.62A4.09,4.09,0,0,1,291.56,165.58Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 292.4,
    cy: 161.65,
    rx: 3.17,
    ry: 2.3,
    transform: "translate(-20.19 279.63) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "267.7 145.38 267.7 160.38 274.35 158.22 274.35 143.22 267.7 145.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 254.4,
    y1: 152.7,
    x2: 264.27,
    y2: 149.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 254.4,
    y1: 155.7,
    x2: 264.27,
    y2: 152.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 254.4,
    y1: 158.7,
    x2: 264.27,
    y2: 155.44
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "254.4 164.7 264.37 161.46 264.37 176.46 254.4 179.7 254.4 164.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 269.35,
    y1: 174.84,
    x2: 276,
    y2: 172.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 278.99,
    y1: 171.71,
    x2: 285.64,
    y2: 169.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 289.19,
    y1: 168.39,
    x2: 295.84,
    y2: 166.23
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "182.47 93.37 182.47 39.37 235.67 70.08 235.67 124.08 182.47 93.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "182.47 39.37 265.6 12.36 318.8 43.07 235.67 70.08 182.47 39.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "235.67 124.08 365.35 81.95 318.8 43.07 235.67 70.08 235.67 124.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "242.32 73.92 242.32 115.92 315.47 92.15 315.47 50.15 242.32 73.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "189.12 49.21 189.12 52.21 229.02 75.24 229.02 72.24 189.12 49.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "189.12 55.21 189.12 58.21 229.02 81.24 229.02 78.24 189.12 55.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "189.12 61.21 189.12 64.21 229.02 87.24 229.02 84.24 189.12 61.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "189.12 67.21 189.12 70.21 229.02 93.24 229.02 90.24 189.12 67.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "189.12 73.21 189.12 76.21 229.02 99.24 229.02 96.24 189.12 73.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "189.12 79.21 189.12 82.21 229.02 105.24 229.02 102.24 189.12 79.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "189.12 85.21 189.12 88.21 229.02 111.24 229.02 108.24 189.12 85.21"
  })), /*#__PURE__*/React.createElement("use", {
    width: 87.2,
    height: 93.25,
    transform: "translate(135.43 194.45) scale(0.9)",
    xlinkHref: "#Box_01a"
  }), /*#__PURE__*/React.createElement("use", {
    width: 87.2,
    height: 93.25,
    transform: "translate(191.19 225.03) scale(0.9)",
    xlinkHref: "#Box_01a"
  }), /*#__PURE__*/React.createElement("use", {
    width: 87.2,
    height: 93.25,
    transform: "translate(253.04 261.94) scale(0.9)",
    xlinkHref: "#Box_01a"
  }), /*#__PURE__*/React.createElement("use", {
    width: 87.2,
    height: 93.25,
    transform: "translate(320.88 309.83) scale(0.9)",
    xlinkHref: "#Box_01a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fyldning_Inspektion_-_Handlinger",
    "data-name": "Fyldning & Inspektion - Handlinger"
  }, /*#__PURE__*/React.createElement("use", {
    width: 598,
    height: 536.9,
    xlinkHref: "#Machine_Belt_02_New"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineBelt2B);
export default __webpack_public_path__ + "static/media/machine-belt-2-b.e1a007c962a2f84c253c071c59ef44db.svg";
export { ForwardRef as ReactComponent };